<div class="auth-wrapper">
  <div class="auth-section">
    <div class="auth-container">
      <div class="logo-header">
        <img src="../../../assets/login-header.png" alt>
      </div>
      <div class="logo-description">
        <h6>Verify OTP</h6>
        <p>A One-Time Password (OTP) has been sent to registered email.<br>
          Please enter the OTP below to continue.</p>
      </div>
      <div class="forms-wrapper pb-3">
        <form class="mt-2" [formGroup]="OtpForm" (ngSubmit)="onSubmit()" autocomplete="off">
          <div class="otp-wrapper mb-3">
            <input autocomplete="off" [type]="showOtp ? 'text' : 'password'" inputmode="numeric" maxlength="1"
              class="form-control otp-control text-center" autofocus formControlName="otp1" id="otp1"
              (input)="onDigitInput($event)" (keydown)="onKeyDown($event)" (paste)="onPaste($event)"
              (focus)="$any($event.target).select()">

            <input autocomplete="off" [type]="showOtp ? 'text' : 'password'" inputmode="numeric" maxlength="1"
              class="form-control otp-control text-center" formControlName="otp2" id="otp2"
              (input)="onDigitInput($event)" (keydown)="onKeyDown($event)" (paste)="onPaste($event)"
              (focus)="$any($event.target).select()">

            <input autocomplete="off" [type]="showOtp ? 'text' : 'password'" inputmode="numeric" maxlength="1"
              class="form-control otp-control text-center" formControlName="otp3" id="otp3"
              (input)="onDigitInput($event)" (keydown)="onKeyDown($event)" (paste)="onPaste($event)"
              (focus)="$any($event.target).select()">

            <input autocomplete="off" [type]="showOtp ? 'text' : 'password'" inputmode="numeric" maxlength="1"
              class="form-control otp-control text-center" formControlName="otp4" id="otp4"
              (input)="onDigitInput($event)" (keydown)="onKeyDown($event)" (paste)="onPaste($event)"
              (focus)="$any($event.target).select()">

            <button type="button" class="otp-toggle-btn" (click)="showOtp = !showOtp"
              [attr.aria-label]="showOtp ? 'Hide OTP' : 'Show OTP'">
              <i class="fa-solid" [ngClass]="showOtp ? 'fa-eye' : 'fa-eye-slash'"></i>
            </button>
          </div>

          <div class="d-grid gap-2 py-3">
            <input class="btn btn-login" type="submit" value="Verify & Proceed">
          </div>
        </form>

        <div class="forget-wrapper my-3 d-flex justify-content-between align-items-center">
          <a *ngIf="resendSeconds === 0" (click)="onResend()" style="cursor:pointer;">
            Resend One-Time Password
          </a>
          <span *ngIf="resendSeconds > 0" class="resend-timer">
            Resend OTP in {{ resendSeconds }}s
          </span>
          <span class="version">ENV:DEVELOPMENT</span>
        </div>
      </div>
    </div>
  </div>
</div>